// extracted by mini-css-extract-plugin
module.exports = {"title":"__title__8pBxD","animate":"__animate__4L_5_","fade-in":"__fade-in__qLiKH"};